import { EventsService, IRISEventsService, USGSEventsService } from './events.service';
import { HttpClient } from '@angular/common/http';
import { StorageMap } from '@ngx-pwa/local-storage';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandleService } from './error-handle.service';
import { SettingsService } from './settings.service';

EventsService
const eventServiceFactory = (
  http: HttpClient,
  errorHandleService: ErrorHandleService,
  storage: StorageMap,
  settingsService: SettingsService,
  translationService: TranslateService
) => {
  switch (settingsService.settings.source) {
    case 'usgs':
      return new USGSEventsService(
        http,
        errorHandleService,
        storage,
        settingsService,
        translationService,
      );
    default:
      return new IRISEventsService(
        http,
        errorHandleService,
        storage,
        settingsService,
        translationService,
      );
  }
};

export const eventServiceProvider = {
  provide: EventsService,
  useFactory: eventServiceFactory,
  deps: [HttpClient, ErrorHandleService, StorageMap, SettingsService, TranslateService]
};
